export default {
    currencyYear: null
}
